import React, { useEffect } from "react";
import { itemBox, userCountInfo } from "../Home";
import { css } from "@emotion/react";
import { useGetExpertHome } from "@src/hooks/queries/useExpert";
import { useNavigate, useLocation } from "react-router-dom";

const ExpertStatBox = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { data, refetch } = useGetExpertHome();
    const handleClick = () => {
        if (pathname === "/experts/home") {
            navigate("/experts/approval/list");
        } else {
            navigate("/experts/home");
        }
    };

    useEffect(() => {
        refetch();
    }, []);
    return (
        <div css={expertStatBox}>
            <div css={itemBox}>
                <div css={userCountInfo} className="cursor" onClick={handleClick}>
                    <p
                        style={{
                            width: "100%",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "14px",
                        }}
                    >
                        <span>매수신청대리인 승인 관리 </span>
                        <span style={{ fontSize: "16px" }}>{" > "}</span>
                    </p>
                </div>
                <div css={userCountInfo}>
                    <p>승인 요청</p>
                    <p className="countText">{data?.auctionAgentRequestedCount ?? 0}</p>
                </div>
                <div css={userCountInfo}>
                    <p>미승인 수정 요구</p>
                    <p className="countText">{data?.auctionAgentRequestedRejectedCount ?? 0}</p>
                </div>

                <div css={userCountInfo}>
                    <p>승인 완료</p>
                    <p className="countText">{data?.auctionAgentRequestedApprovedCount ?? 0}</p>
                </div>
                {/* <div
                    css={userCountInfo}
                    className="cursor"
                    onClick={() => {
                        console.log("click");
                    }}
                >
                    <p>등록자 수</p>
                    <p className="countText">{data?.auctionAgentCount}</p>
                </div> */}
            </div>
        </div>
    );
};

export default ExpertStatBox;

const expertStatBox = css`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;
